module.exports = __webpack_public_path__ + "img/制御工学5_10.1c82c35f.png";